import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 9a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 14v7","key":"svg-1"}],["path",{"d":"M9 18h6","key":"svg-2"}]]

/**
 * IconGenderFemale
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZ2VuZGVyLWZlbWFsZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA5YTUgNSAwIDEgMCAxMCAwYTUgNSAwIDEgMCAtMTAgMCIgLz4KICA8cGF0aCBkPSJNMTIgMTR2NyIgLz4KICA8cGF0aCBkPSJNOSAxOGg2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/gender-female
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconGenderFemale = createReactComponent('outline', 'gender-female', 'GenderFemale', __iconNode);

export default IconGenderFemale;